export default function StyleBox({type, styleBox}) {
    return styleBox ? <div className="ajb-col-4 ajb-col-8-breakpoint margin-top-30-sm">
        <div className="card z-depth-0 margin-0">
            <div className="card-content padding-0">
                <span className="card-title" data-testid="morningStarStyleHeader">Morningstar style box <sup><small data-testid="morningStarStyleSuperScriptHeader">TM</small></sup></span>
                <div className="ajb-grid-row">
                    <div className="ajb-grid-row">
                        <span className="margin-bottom-10 block" data-testid="equityFixedStyleHeader">{type === 1 ? 'Equity style' : 'Fixed income style'}</span>
                    </div>
                    <div className="ajb-grid-row margin-bottom-10">
                        <div className="ajb-col-collapse">
                            <div className={`ajb-col-3 ajb-col-2-breakpoint padding-30 ${styleBox == 1 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox1"></div>
                            <div className={`ajb-col-3 ajb-col-2-breakpoint margin-left-10 padding-30 ${styleBox == 2 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox2"></div>
                            <div className={`ajb-col-3 ajb-col-2-breakpoint margin-left-10 padding-30 ${styleBox == 3 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox3"></div>
                            <div className="ajb-col-3 ajb-col-2-breakpoint">
                                <span className="h7 grey-500-text" data-testid="styleBoxLargeLabel">
                                    <span className="font-weight-bold block margin-0 black-text" style={{lineHeight: 1}}>
                                        <small data-testid="styleBoxSizeCreditAxis">{type === 1 ? 'Size' : 'Credit quality'}</small>
                                    </span>
                                    Large
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="ajb-grid-row margin-bottom-10">
                        <div className="ajb-col-collapse">
                        <div className={`ajb-col-3 ajb-col-2-breakpoint padding-30 ${styleBox == 4 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox4"></div>
                            <div className={`ajb-col-3 ajb-col-2-breakpoint margin-left-10 padding-30 ${styleBox == 5 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox5"></div>
                            <div className={`ajb-col-3 ajb-col-2-breakpoint margin-left-10 padding-30 ${styleBox == 6 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox6"></div>
                            <div className="ajb-col-3 ajb-col-2-breakpoint">
                                <span className="h7 grey-500-text" data-testid="styleBoxMidLabel">
                                    Mid
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="ajb-grid-row margin-bottom-10">
                        <div className="ajb-col-collapse">
                        <div className={`ajb-col-3 ajb-col-2-breakpoint padding-30 ${styleBox == 7 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox7"></div>
                            <div className={`ajb-col-3 ajb-col-2-breakpoint margin-left-10 padding-30 ${styleBox == 8 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox8"></div>
                            <div className={`ajb-col-3 ajb-col-2-breakpoint margin-left-10 padding-30 ${styleBox == 9 ? 'darkblue-500-bg' : 'grey-0-bg'} c-box`} data-testid="styleBox9"></div>
                            <div className="ajb-col-3 ajb-col-2-breakpoint">
                                <span className="h7 grey-500-text" data-testid="styleBoxSmallLabel">
                                    Small
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="ajb-grid-row margin-bottom-0">
                        <div className="ajb-col-collapse">
                            <div className="ajb-col-3 ajb-col-2-breakpoint">
                                <span className="h7 grey-500-text" data-testid="styleBoxValueLabel">Value</span>
                            </div>
                            <div className="ajb-col-3 ajb-col-2-breakpoint">
                                <span className="h7 grey-500-text" data-testid="styleBoxBlendLabel">Blend</span>
                            </div>
                            <div className="ajb-col-3 ajb-col-2-breakpoint">
                                <span className="h7 grey-500-text" data-testid="styleBoxGrowthLabel">Growth</span>
                            </div>
                        </div>
                    </div>
                    <div className="ajb-grid-row margin-bottom-0">
                        <div className="ajb-col-collapse">
                            <div className="ajb-col-12 ajb-col-8-breakpoint">
                                <span className="h7 font-weight-bold block margin-0 black-text">
                                    <small data-testid="styleBoxStyleInterestAxis">{type === 1 ? 'Style' : 'Interest rate sensit'}</small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> : null
}